import { translate } from 'shared/services/I18nService';

export const noteTool = {
  install (toolbox) {
    return toolbox.extend('note', {
      action () {
        const annotationsService = this.VIEWPORT.plugins('us:annotations:service');
        const region = annotationsService.getSelRegion();
        if (!region) {
          return;
        }

        let messageType = 'default';
        let callback = (cursorPosition, note) => annotationsService.regAddNote(note);

        if (region.shape === 'text') {
          messageType = 'text';
          callback = annotationsService.onAddImageText;
        } else if (region.isReportRegion) {
          messageType = 'report';
          callback = annotationsService.onAddImageText;
        }

        const textEditPanel = this.USCOPE.plugins('us:annotations:text-edit-panel');
        textEditPanel.openTextEditPanel(translate(`uScope.extensions.annotations.add-note-message.${messageType}`), region.note, callback);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/note.js